import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { __t, applyTranslations } from 'utils/language';
import {
  DEFAULT_SORT_OPTION,
  DISCOVERY_CONTENT_SORT_OPTIONS
} from '../../utils/content';

import './discovery-content-sort.scss';

import type {
  Data,
  MixedSelectDropdownItem
} from 'types';

applyTranslations(require('./discovery-content-sort.i18n.json'));

type Props = {
  sort: string,
  onSort: (a: string) => void
};

const msgKey = 'discovery_content_sort';

const DiscoveryContentSort = (
  {
    sort,
    onSort
  }: Props
): JSX.Element => {
  const sortKeys = Object.keys(DISCOVERY_CONTENT_SORT_OPTIONS);

  const getDropdownItems = (): Array<MixedSelectDropdownItem> => (
    (sortKeys || []).map(value => ({
      identifier: value,
      isDisabled: false,
      isSelected: sort === value,
      label: __t(`${msgKey}.sort.${DISCOVERY_CONTENT_SORT_OPTIONS[value]}`),
      value
    }))
  );

  const handleUpdateSort = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => (
    onSort(selectedItem?.value || DEFAULT_SORT_OPTION)
  );

  const items = getDropdownItems();

  return (
    <div className="discovery-content-sort">
      <div className="discovery-content-sort__label">
        {__t(`${msgKey}.labels.sort`)}:
      </div>
      <MixedSelectDropdown
        key={`discovery-creators-sort__${sort}`}
        name="discovery-creators-sort__dropdown"
        items={items}
        withSelectedInList
        className="discovery-content-sort__dropdown"
        onItemsToggle={handleUpdateSort}
      />
    </div>
  );
};

export default DiscoveryContentSort;
